import { render, staticRenderFns } from "./CmgAddressValidationResult.vue?vue&type=template&id=5703f7df&scoped=true&lang=pug&"
import script from "./cmg-address-validation-result.ts?vue&type=script&lang=ts&"
export * from "./cmg-address-validation-result.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAddressValidationResult.vue?vue&type=style&index=0&id=5703f7df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703f7df",
  null
  
)

export default component.exports